import type { ProjectDto } from '@pb/shared';
import { asList, get, patch, post, query } from './client';

export const listProjects = async (includeArchived: boolean) =>
  asList(await get<ProjectDto[] | { items: ProjectDto[] }>(`/projects${query({ include_archived: includeArchived })}`));
export const createProject = (name: string, description: string) =>
  post<ProjectDto>('/projects', { name, description });
export const getProject = (id: number) => get<ProjectDto>(`/projects/${id}`);
export const updateProject = (id: number, input: { name?: string; description?: string }) =>
  patch<ProjectDto>(`/projects/${id}`, input);
export const archiveProject = (id: number, archived: boolean) =>
  post<ProjectDto>(`/projects/${id}/archive`, { archived });
